import { Component, Inject, Input, OnChanges, OnDestroy, OnInit, PLATFORM_ID } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import * as dayjs from 'dayjs';
import { Observable, Subscription } from 'rxjs';
import { map, tap, filter, switchMap } from 'rxjs/operators';
import { ItineraryResult } from 'src/app/shared/models/itinerary-result.interface';

import { Itinerary } from '../../shared/models/itinerary.interface';
import { ItineraryService } from '../../shared/services/itinerary.service';
import { isPlatformBrowser, isPlatformServer } from '@angular/common';

@Component({
	selector: 'app-itinerary-navigator',
	templateUrl: './itinerary-navigator.component.html'
})
export class ItineraryNavigatorComponent implements OnInit, OnDestroy, OnChanges {

	//@Input() destinationSlug: string = null;
	@Input() arriveDate: string = null;
	
	public itinerary: Itinerary = null;
	public itinerary$: Observable<Itinerary>;
	public itinerarySub: Subscription;

	public currentDay: number = null;
	public prevDay: number;
	public prevDest: ItineraryResult;
	public nextDay: number;
	public nextDest: ItineraryResult;

	public showNavigatorPanel: boolean = false;

	public href: string = "";
	public routeToItinerary: boolean = false;

	constructor(
		private _itineraryService: ItineraryService,
		//private route: ActivatedRoute,
		private router: Router,
		@Inject(PLATFORM_ID) private platformId: Object,
	) { 
		if(isPlatformServer(platformId)){
			return; 
		}
	}

	ngOnInit(): void {
		//console.log('ItineraryNavigatorComponent.ngOninit.arriveDate:',this.arriveDate);
		if(isPlatformBrowser(this.platformId)){
			this.itinerarySub = this._itineraryService.itinerary$
				.subscribe((data: Itinerary) => {
					//console.log('ItineraryNavigatorComponent.itinerary:', data);
					if(!data) {
						this.itinerary = null;
						return null;
					}
					return this.processData(data);
				});
			const storageItinerary = this._itineraryService.getItinerary();
			//console.log('ItineraryNavigatorComponent.storageItinerary:', storageItinerary);

			if(storageItinerary) this.processData(storageItinerary);
		}
	}

	ngOnChanges(): void{
		//console.log('ItineraryNavigatorComponent.ngOnChanges.arriveDate:', this.arriveDate);
		this.checkForDestinationDay();
	}

	ngOnDestroy(): void{
		//console.log('ItineraryNavigatorComponent.ngOnDestroy');
		this.itinerarySub?.unsubscribe();
	}

	public processData(itinerary: Itinerary) {
		//console.log('ItineraryNavigatorComponent.processData:', itinerary);

		this.itinerary = itinerary;
		this.checkForDestinationDay();
		return itinerary;
	}

	public checkForDestinationDay() {
		this.currentDay = null;
		if(!this.itinerary || !this.arriveDate) return;
		this.itinerary.results.forEach(item => {
			//console.log('item:', item);
			if(item.arriveDateStr == this.arriveDate){
				this.currentDay = item.day;
			}
		});
		this.href = this.router.url.toLowerCase();
		if(this.href.indexOf('cruises') != -1 || this.href.indexOf('empty') != -1){
			this.routeToItinerary = true;
		} else {
			this.routeToItinerary = false;
		}
		//console.log('this.href:', this.href, this.routeToItinerary);
		//console.log('ItineraryNavigatorComponent.checkForDestinationDay.currentDay:', this.currentDay);

		this.prevDay = this.currentDay ? this.currentDay-2 : 0;
		this.prevDest = this.itinerary.results[this.prevDay];
		// console.log('ItineraryNavigatorComponent.nextDay.prevDay:', prevDay);
		//console.log('ItineraryNavigatorComponent.nextDay.prevDest:', prevDest);
		this.nextDay = this.currentDay ? this.currentDay : 0; //(currentDay is already +1 relative to arrays starting at index-0)
		this.nextDest = this.itinerary.results[this.nextDay];
		//console.log('ItineraryNavigatorComponent.nextDay.nextDay:', nextDay);
		//console.log('ItineraryNavigatorComponent.nextDay.nextDest:', nextDest);
	}

	public gotoPrevDay() {
		//console.log('gotoPrevDay().currentDay:', this.currentDay);

		if(this.prevDest.destinationSlugPath) {
			this.router.navigate([this.prevDest.destinationSlugPath], { queryParams: { date: dayjs(this.prevDest.arriveDate).format('YYYY-MM-DD') }});
		}
	}

	public gotoNextDay() {
		//console.log('gotoNextDay().currentDay:', this.currentDay);

		if(this.nextDest.destinationSlugPath) this.router.navigate([this.nextDest.destinationSlugPath], { queryParams: { date: dayjs(this.nextDest.arriveDate).format('YYYY-MM-DD') }});
	}

	public openPanel() {
		//console.log('openPanel()');
		this.showNavigatorPanel = true;
	}

	public closePanel(item?: any){
		this.showNavigatorPanel = false;
		if(item){
			this.router.navigate([item.destinationSlugPath], {queryParams: {date: item.arriveDateStr}}); 
		}
	}

	public deleteItinerary(){
		this.closePanel(); 
			if(isPlatformBrowser){
			this._itineraryService.clearItinerary();
			//console.log('this.routeToItinerary:', this.routeToItinerary);
			if(this.routeToItinerary) {
				this.router.navigate(['/cruises']);
			}
		}
	}

}
